import { useMutation } from '@tanstack/react-query';

export function useCreateProjectsAnalyticsFilterSelectionConfigurationsBulkUpdateProcessMutation() {
  return useMutation({
    mutationFn: async ({ bulkUpdateProcessParams }) => {
      fetch(
        'projects_analytics/filter_selection_configurations/bulk_update_processes',
        {
          body: JSON.stringify({
            authenticity_token: (
              document.querySelector('meta[name="csrf-token"]') || {}
            ).content,
            bulk_update_process: bulkUpdateProcessParams,
          }),
          headers: { 'Content-Type': 'application/json' },
          keepalive: true,
          method: 'POST',
        },
      );
    },
  });
}
